import React, { useState } from 'react';
import { axisMaxTextLogo, checkmarkBlack } from '../../images/images';
import { CallMade } from '@material-ui/icons';

const LinkViewCard = ({ policy, setIsLoading, redirectToLink }) => {
    const { policyNumber, posvRefNumber, recordDt, journeyCompleted, productName } = policy;
    const [alertData, setAlertData] = useState({
        open: false,
        type: "",
        msg: "",
        actions: []
    });
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { day: 'numeric', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('en-GB', options);
    };
    return (
        <>
            <div className="link-view-card">
                <div className='link-view-card-header'>
                    {/* <img src={axisMaxTextLogo} alt='axisMaxTextLogo' /> */}
                    <p className={`policy-status ${journeyCompleted ? '' : 'pending'}`}>
                        <span className='policy-status-icon'></span>
                        <span className='policy-status-text'>{journeyCompleted ? 'Done' : 'Pending'}</span>
                    </p>
                </div>
                <div className="link-view-card-body">
                    <div className="link-view-card-title" >
                        <p className='plan-name'>{productName}</p>
                        <p className='policy-number'>Policy Number: {policyNumber}</p>
                        <p className='init-date'>Initiated on {formatDate(recordDt.split(" ")[0].split(":").join("-"))}</p>
                    </div>

                    <p className="link-view-card-text pending">Due Date : <span>N/A</span></p>
                </div>
                {
                    journeyCompleted ?
                        <div className='link-view-card-footer'>
                            <p className='link-view-card-text-complete'> <img src={checkmarkBlack} alt='check_icn' /> Policy verification has already been done</p>
                        </div> : (
                            <div className='start-verification' onClick={() => redirectToLink(posvRefNumber)}>
                                <p>Start Verification</p>
                                <CallMade width={"20px"} />
                            </div>
                        )
                }
            </div>
        </>
    );
};

export default LinkViewCard;